import { createSelector } from "reselect";
export const getCurrentLandingPage = state => state?.landingPage?.current;
const getLandingPageProducts = state => state?.landingPage?.products;
const getLandingPageCatalogProducts = state => state?.landingPage?.catalogProducts;
export const getLandingPageMeta = state => state?.landingPage?.current?.meta;

export const getProductsOfLandingPage = createSelector(
	[getLandingPageProducts, getLandingPageCatalogProducts],
	(products = [], catalogProducts = []) => {
		const allProducts = products?.concat(catalogProducts);
		const nonFlashsaleProducts = allProducts?.filter(product => {
			return product.isFlashsale === false;
		});
		return nonFlashsaleProducts;
	}
);

// TODO temporaire (voir FBR-2686)
export const shouldLandingPageHideProductPriceBanner = createSelector(
	[getCurrentLandingPage],
	(landingPage = {}) => {
		return !landingPage?.topicFilterValues?.some(topic =>
			["Circuit", "Autotour", "Croisière", "Combiné"].includes(topic)
		);
	}
);
